<!--begin::Subheader-->
<div class="subheader py-2 pb-1 pt-1" id="kt_subheader">
    <div class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap container-fluid">
        <div class="d-flex align-items-center flex-wrap me-1">
            <ng-container *ngIf="subheaderMobileToggle">
                <button class="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none" id="kt_subheader_mobile_toggle">
                    <span></span>
                </button>
            </ng-container>

            <div class="d-flex flex-column">
                <ng-container>
                    <h2 class="text-white font-weight-bold my-2 me-5" style="font-size: 30px">
                        <a class="inactive-icon">
                            <img [src]="imgSrc" alt="" (mouseenter)="onMouseOver()" (mouseleave)="onMouseOut()" />
                        </a>
                        <ng-container >
                            {{ headerData.displayText }}
                        </ng-container>
                    </h2>
                </ng-container>
            </div>
        </div>

        <div class="d-flex justify-content-end">
            <div class="activity_header_wrapper d-flex align-items-center justify-content-end w-100">
                <span *ngIf="currentOrganizationName" class="activity_title">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.ORGANIZATION_NAME' | transloco }}</span>
                <span *ngIf="currentOrganizationName" class="section-data">{{ currentOrganizationName }}</span>
                <span *ngIf="currentInstanceName" class="activity_title">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.INSTANCE_NAME' | transloco }}</span>
                <span *ngIf="currentInstanceName" class="section-data">{{ currentInstanceName }}</span>
                <span class="activity_title" *ngIf="currentAssetType">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.ASSET_TYPE' | transloco }}</span>
                <span class="section-data" *ngIf="currentAssetType">{{ currentAssetType }}</span>
            </div>
            <div class="d-flex align-items-center">
                <div
                    class="dropdown dropdown-inline ml-2"
                    data-toggle="tooltip"
                    title="{{ 'SETTING_PAGE.IDMS_SETTINGS.QUICK_ACTIONS' | transloco }}"
                    data-placement="left"
                    placement="bottom-right"
                    ngbDropdown
                >
                    <div class="flex-row justify-content-end">
                        <div class="d-flex flex-row justify-content-end">
                            <app-settings-language
                                *ngIf="headerData.isGeneralSettings"
                                (languageOutput)="languageOutputHandler($event)"
                            ></app-settings-language>
                            <app-shared-content-add-update
                                *ngIf="headerData.isGeneralSettings && isAddEnabled === true"
                                [language]="language"
                                [sharedContentType]="sharedContentType"
                                [generalTabIndex]="generalTabIndex"
                            ></app-shared-content-add-update>
                        </div>
                        <button
                            *ngIf="
                                !headerData.isGeneralSettings &&
                                !headerData.isInstanceSettings &&
                                headerData?.displayTitle != 'User Profile' &&
                                !headerData.isIdmsSettings
                            "
                            class="btn primary-ebtn font-weight-bold py-3 px-6"
                            (click)="saveSettings($event)"
                            [disabled]="saveDisabled()"
                        >
                            {{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.SAVE' | transloco }}
                        </button>
                        <button
                            *ngIf="headerData.isInstanceSettings"
                            class="btn primary-ebtn font-weight-bold py-3 px-6"
                            (click)="saveInstanceSettings($event)"
                            [disabled]="!isSaveEnabled"
                        >
                            {{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.SAVE' | transloco }}
                        </button>

                        <app-communication-dropdown *ngIf="isNotificationAddButton && headerData?.displayTitle == 'User Profile'"></app-communication-dropdown>
                        <button
                            *ngIf="headerData?.displayTitle === 'User Profile' && !isNotificationAddButton"
                            class="btn primary-ebtn font-weight-bold py-3 px-6 ml-3"
                            (click)="saveProfileData()"
                            [disabled]="disableEditProfile()"
                        >
                            {{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.SAVE' | transloco }}
                        </button>

                        <button
                            class="btn primary-ebtn font-weight-bold py-3 px-6"
                            (click)="saveIdmsSetting()"
                            [disabled]="disableHandlerForIdmsSettings()"
                            *ngIf="
                                headerData.isIdmsSettings &&
                                generalTabIndex != 'DB Select Lookup & Material Alias' &&
                                generalTabIndex != 'Batch Calculation Status' &&
                                generalTabIndex != 'Approvals'
                            "
                        >
                            {{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.SAVE' | transloco }}
                        </button>
                    </div>
                </div>
               
            </div>
        </div>
    </div>
</div>
